module.exports = __webpack_public_path__ + "static/media/location-maps-letter-h.1d50c02c.png";